import { useDispatch, useSelector } from "react-redux";
import { fetchFunctionDefinitions } from "../actions/functions";
import {
  NewFunctionDestination,
  SaaSDestination,
} from "../destinations/destinations";
import { FunctionSlug } from "../destinations/types";
import { FunctionDefinition } from "../functions/types";

export const useFunctionDestinations = (): Record<string, SaaSDestination> => {
  const {
    functionDefs,
    isLoaded,
  }: { functionDefs: FunctionDefinition[]; isLoaded: boolean } = useSelector(
    (state) => (state as any).functionDefs
  );

  const dispatch = useDispatch();

  if (!isLoaded) {
    dispatch(fetchFunctionDefinitions());
    return {};
  }

  const functionDestinations = functionDefs
    .filter((functionDef) => functionDef.type === "DESTINATION")
    .map((functionDef) => {
      return NewFunctionDestination({
        slug: functionDef.id,
        name: functionDef.name,
        config: functionDef.config || {
          configFields: [],
        },
      });
    });

  const functionDestinationsMap: Record<FunctionSlug, SaaSDestination> = {};

  for (const functionDestination of functionDestinations) {
    functionDestinationsMap[functionDestination.slug] = functionDestination;
  }

  return functionDestinationsMap;
};
